import { useMemo } from 'react';

import { Dependent, DEPENDENT_RELATIONSHIP_ME } from '@/modules/employee/employee.types';
import { useGetDependentsQuery } from '@/modules/employee/Employee/Dependents/hooks/useDependents.query';

export interface DeductibleUser {
  id: string;
  fullName: string;
  isMe?: boolean;
  relationshipType?: string;
}

interface Params {
  userId?: string;
  employeeUser?: DeductibleUser
  isIndividual?: boolean;
}
export default ({ userId, isIndividual, employeeUser }: Params) => {
  const { dependents, isLoading } = useGetDependentsQuery(employeeUser?.id || '');

  const users = useMemo(() => {
    if (isLoading) {
      return [];
    }
    const me = {
      dependentId: employeeUser?.id || '',
      fullName: employeeUser?.fullName || '',
      relationshipType: DEPENDENT_RELATIONSHIP_ME,
    };

    const list = [me, ...dependents] as Dependent[];

    if (!isIndividual) {
      return list;
    }
    const found = list.find((currentUser) => currentUser.dependentId === userId);

    if (found) {
      return [found];
    }
    return [me];
  }, [isLoading, employeeUser, dependents, isIndividual, userId]);
  return users;
};
